/**
 * Downloads the badge image directly from its source URL at full resolution.
 * Falls back to fetching as blob for cross-origin images (S3).
 */
export async function downloadBadgeImage(imageUrl, filename) {
    try {
        const response = await fetch(imageUrl, { mode: 'cors' });
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = filename || 'sdsic-badge.png';
        link.href = blobUrl;
        link.click();
        URL.revokeObjectURL(blobUrl);
    } catch (err) {
        // Fallback: open image in new tab if fetch fails (e.g. CORS)
        console.error('Download failed, opening in new tab:', err);
        window.open(imageUrl, '_blank');
    }
}
